import { ref, watch } from 'vue'
export interface AsyncImageData {
  id: number
  index: number
  url: string
  width: number | null
  height: number | null
  alt: string
  ready: boolean
  show: boolean
}

export const useShowImage = (imageCount: number) => {
  const imagesPayload: Map<number, AsyncImageData> = new Map([])
  const firstImagePayloadBatchCount = ref<number>(imageCount > 3 ? 3 : imageCount)
  const currentImageIndexToLoad = ref<number>(0)
  const showImages = ref<boolean>(false)
  const getImage = (id: number) => {
    if (imagesPayload) {
      return imagesPayload.get(id)
    }
  }
  const loadNext = (): void => {
    currentImageIndexToLoad.value++
  }
  const toggleReady = (id: number): void => {
    const image = imagesPayload.get(id)
    if (image !== undefined) {
      image.ready = true
    }
  }

  watch(currentImageIndexToLoad, newValue => {
    if (newValue >= firstImagePayloadBatchCount.value) {
      showImages.value = true
    }
  })

  return {
    showImages,
    toggleReady,
    getImage,
    loadNext,
    imagesPayload,
    currentImageIndexToLoad,
    firstImagePayloadBatchCount
  }
}
